import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: flex-start;
  column-gap: 12px;
`;

interface ModalFooterContentButtonGroupsProps {
  children?: React.ReactNode;
}

export const ModalFooterContentButtonGroups = (props: ModalFooterContentButtonGroupsProps) => {
  const { children } = props;

  return <Container>{children}</Container>;
};
